/** @jsx jsx */
import { jsx } from 'theme-ui';
import AppError from './AppError';

const PageError = ({ ...props }) => {
  return <AppError {...props} />;
};

export default PageError;
